<template>
  <div class="clock-widget text-center">
    <div class="clock-widget__time">{{ time }}</div>
    <div class="clock-widget__date text-muted">{{ date }}</div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: { config: { type: Object, default: () => ({}) } },
  data() {
    return { now: new Date(), timer: null }
  },
  computed: {
    tz() { return this.config.timezone || 'Asia/Jakarta' },
    time() {
      return moment(this.now).tz(this.tz).format(this.config.format24h !== false ? 'HH:mm:ss' : 'hh:mm:ss A')
    },
    date() {
      return moment(this.now).tz(this.tz).format('dddd, D MMM YYYY')
    },
  },
  mounted() {
    this.timer = setInterval(() => { this.now = new Date() }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style scoped>
.clock-widget__time {
  font-size: var(--ws-display-size, 32px);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--ws-text);
}
.clock-widget__date {
  font-size: 0.85em;
  color: var(--ws-text-muted);
}
</style>
